import * as React from 'react';

import {AccountChildOverlayIcon} from '../icon/svg/account-child-overlay-icon';

import {Avatar} from './avatar';

import styles from './account-avatar.module.css';

const CHILD_AVATAR_SIZE_TO_CONTAINER_SIZE_RATIO = 0.875;
const MAX_CHILD_COUNT_DISPLAYED = 99;

const CHILD_PATTERN = /parent=[0-9]+/;
const PARENT_PATTERN = /children=[0-9]+/;

type Props = {
    avatarUrl: string | null | undefined;
    size?: number;
};

export const AccountAvatar = (props: Props) => {
    const {size = 32} = props;
    const overlaySize = size / 2;

    let isChild = false;
    let isParent = false;
    let childrenCount = null;
    let maxChildCountReached = false;
    if (props.avatarUrl) {
        const avatarUrl: string = props.avatarUrl;

        isChild = CHILD_PATTERN.test(avatarUrl);
        isParent = PARENT_PATTERN.test(avatarUrl);

        if (isParent) {
            const match = avatarUrl.match(PARENT_PATTERN);

            if (match) {
                const keyValuePair = match[0].split('=');
                childrenCount = Number(keyValuePair[1]);
                maxChildCountReached = childrenCount > MAX_CHILD_COUNT_DISPLAYED;
            }
        }
    }

    return (
        <div style={{width: size, height: size}} className={styles.container}>
            {isParent || isChild ? (
                <>
                    {isParent ? (
                        <>
                            <Avatar
                                avatarUrl={props.avatarUrl}
                                type='accounts'
                                isParent={true}
                                size={size}
                            />
                            <div
                                style={{
                                    width: overlaySize,
                                    height: overlaySize,
                                    // @ts-expect-error
                                    fontSize: maxChildCountReached ? 7 : null,
                                }}
                                className={styles['child-count-overlay']}
                            >
                                {maxChildCountReached ? '99+' : childrenCount}
                            </div>
                        </>
                    ) : (
                        <div className={styles['child-container']}>
                            <Avatar
                                avatarUrl={props.avatarUrl}
                                type='accounts'
                                size={size * CHILD_AVATAR_SIZE_TO_CONTAINER_SIZE_RATIO}
                            />
                            <div className={styles['child-overlay']}>
                                <AccountChildOverlayIcon size={overlaySize} />
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <Avatar avatarUrl={props.avatarUrl} type='accounts' size={size} />
            )}
        </div>
    );
};
